import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import Loader from "../components/Loader";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faUserGroup,
  faFloppyDisk,
} from "@fortawesome/free-solid-svg-icons";
import isEqual from "lodash/isEqual";
import { CloseIcon, ModernButton } from "./DefaultImports";
import { CustomModal } from "../components/CustomModal";
import zIndex from "@mui/material/styles/zIndex";

function cleanList(list) {
  return list.map((sublist) => {
    return sublist.map((item) => {
      const splitItem = item.split(";");
      return { number: splitItem[0], status: splitItem[1] };
    });
  });
}
const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(33, 33, 33, 0.5);
  z-index: 2000;
`;

const StyledTableDiv = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #bbb;
  border-radius: 6px;
  padding: 6px;
  margin: 6px;
  font-weight: 500;
  font-size: 14px;
  text-align: center;

  cursor: pointer;
  transition: all 0.2s ease-in-out;

  background-color: ${({ isSelected, tableStatus }) =>
    isSelected
      ? tableStatus === "1"
        ? "#EE561B"
        : "#f79574"
      : tableStatus === "1"
      ? "#99B0AD"
      : "#FFFFFF"}; // livre

  color: ${({ isSelected, tableStatus }) =>
    isSelected || tableStatus === "1" ? "white" : "#4B3335"};

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    border-color: #ee754c;
  }
`;

const StyledH6 = styled.h6`
  color: ${({ enoughSeats }) => (enoughSeats ? "green" : "red")};
`;

const ZoneContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const LegendContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 15px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
`;

const LegendColor = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 3px;
  background-color: ${({ color }) => color};
  border: 1px solid #bbbbbb; /* ou #333, conforme desejado */
`;

const TablesModal = ({
  show,
  tables_list,
  onClose,
  initialSelectedTables,
  token,
  id,
  numPeople,
  handleTablesUsedChange,
  setSelectedTablesSave,
  setPlaceOfTable,
  placeOfTable,
  setEnoughSeatsReservation,
}) => {
  const tables = cleanList(tables_list);
  const all_tables = useSelector((state) => state.restaurantTables.tables);
  const connectTablesConfig = useSelector(
    (state) => state.connectTablesConfig.connectTablesConfig
  );
  const [enoughSeats, setEnoughSeats] = useState(false);
  const [countPeople, setCountPeople] = useState(0);
  const [tablesConfigList, setTablesConfigList] = useState([]);
  const [selectedTables, setSelectedTables] = useState({});
  const [firstTimeOnly, setFirstTimeOnly] = useState(true);

  useEffect(() => {
    // Check if selectedTables is empty
    console.log("piu 1");
    if (
      Object.keys(selectedTables).length === 0 &&
      tables_list &&
      !(tables_list.length === 0)
    ) {
      console.log("piu 2");
      if (firstTimeOnly) {
        console.log("piu 3");
        setSelectedTables(initialSelectedTables);
        setFirstTimeOnly(false);
      }
    }
  }, [initialSelectedTables, all_tables, tables_list]);

  useEffect(() => {
    if (connectTablesConfig) {
      const table_config = Object.values(connectTablesConfig).map(
        (config) => config.number_of_chairs
      );
      setTablesConfigList(table_config);
    }
  }, [connectTablesConfig]);

  useEffect(() => {
    if (tables_list && selectedTables) {
      const updatedSelectedTables = {};

      tables_list.forEach((zoneTables) => {
        const zoneName = zoneTables[0];
        const tablesWithStatusOne = zoneTables
          .slice(1)
          .filter((table) => table.split(";")[1] === "1")
          .map((table) => table.split(";")[0]);

        if (selectedTables[zoneName]) {
          const filteredTables = selectedTables[zoneName].filter(
            (table) => !tablesWithStatusOne.includes(table.number)
          );
          if (filteredTables.length > 0)
            updatedSelectedTables[zoneName] = filteredTables;
        }
      });

      if (!isEqual(updatedSelectedTables, selectedTables)) {
        setSelectedTables(updatedSelectedTables);
        setSelectedTablesSave && setSelectedTablesSave(updatedSelectedTables);
        handleTablesUsedChange &&
          handleTablesUsedChange(
            Object.values(updatedSelectedTables)
              .flat()
              .map((table) => table.number)
          );
      }
    }
  }, [tables_list]);

  useEffect(() => {
    if (all_tables) {
      // 1. Retrieve all the table numbers from selectedTables
      let selectedTableNumbers = [];
      for (let key in selectedTables) {
        selectedTables[key].forEach((table) => {
          selectedTableNumbers.push(table.number);
        });
      }

      if (typeof handleTablesUsedChange === "function") {
        handleTablesUsedChange(selectedTableNumbers);
      }

      // 2. Filter out the tables from all_tables using the retrieved table numbers
      const filteredTables = all_tables.filter((table) =>
        selectedTableNumbers.includes(table.id.toString())
      );

      // 3. Sum the number of seats of each filtered table
      const totalSeats = filteredTables.reduce(
        (acc, table) => acc + parseInt(table.number_of_seats),
        0
      );

      // Logic for summing values from tablesConfigList
      let numOfTables = filteredTables.length;
      let configSum = 0;
      if (numOfTables >= 2) configSum += tablesConfigList[0];
      if (numOfTables >= 3) configSum += tablesConfigList[1];
      if (numOfTables >= 4) configSum += tablesConfigList[2];
      for (let i = 5; i <= numOfTables; i++) {
        configSum += tablesConfigList[((i + 1) % 2) + 1];
      }

      if (totalSeats + configSum >= numPeople) {
        setEnoughSeats(true);
      } else {
        setEnoughSeats(false);
      }
      setCountPeople(totalSeats + configSum);
    }
  }, [selectedTables, all_tables]);

  useEffect(() => {
    if (typeof setSelectedTablesSave === "function") {
      setSelectedTablesSave(selectedTables);
    }
  }, [selectedTables, setSelectedTablesSave]);

  const handleTableSelect = (table, zone) => {
    if (placeOfTable !== zone) {
      setPlaceOfTable(zone);
      setSelectedTables({});
    }
    setSelectedTables((prevSelectedTables) => {
      const updatedTables = { ...prevSelectedTables };
      if (updatedTables[zone]?.some((t) => t.number === table.number)) {
        updatedTables[zone] = updatedTables[zone].filter(
          (t) => t.number !== table.number
        );
      } else {
        updatedTables[zone] = [
          ...(updatedTables[zone] || []),
          { number: table.number, status: table.status },
        ];
      }
      return updatedTables;
    });
  };

  useEffect(() => {
    if (typeof setEnoughSeatsReservation === "function") {
      setEnoughSeatsReservation(enoughSeats);
    }
  }, [enoughSeats, setEnoughSeatsReservation]);

  useEffect(() => {
    console.log(
      "---------------------------||START||-------------------------"
    );
    console.log("initialSelectedTables: ", initialSelectedTables);
    console.log("enoughSeats: ", enoughSeats);
    console.log("selectedTables: ", selectedTables);
    console.log("tables_list: ", tables_list);
    console.log("selectedTables: ", selectedTables);
    console.log("---------------------------||END||-------------------------");
  }, [initialSelectedTables, enoughSeats, selectedTables, tables_list]);

  return (
    <CustomModal
      show={show}
      onHide={onClose}
      title="Atribuir mesas"
      centered={false}
      footer={
        <>
          <LegendContainer>
            <LegendItem>
              <LegendColor color="FFFFFF" /> Livre
            </LegendItem>
            <LegendItem>
              <LegendColor color="#99B0AD" /> Ocupada
            </LegendItem>
            <LegendItem>
              <LegendColor color="#f79574" /> Selecionada
            </LegendItem>
            <LegendItem>
              <LegendColor color="#EE561B" /> Selecionada (mas ocupada)
            </LegendItem>
          </LegendContainer>
          <ModernButton color="#99B0AD" onClick={onClose}>
            Cancelar
          </ModernButton>
          <ModernButton
            color="#de8c3a"
            onClick={onClose}
            style={{ marginLeft: "8px" }}
          >
            Atribuir mesas selecionadas
          </ModernButton>
        </>
      }
    >
      <Row style={{ width: "100%" }}>
        <Col
          className="d-flex justify-content-center"
          xs={12}
          style={{ marginTop: "5px", marginBottom: "10px" }}
        >
          <StyledH6 enoughSeats={enoughSeats}>
            <FontAwesomeIcon
              icon={faUserGroup}
              style={{
                color: enoughSeats ? "green" : "red",
                marginRight: "8px",
              }}
            />
            <strong>{countPeople} lugares</strong> atribuídos para{" "}
            <strong>{numPeople} pessoas</strong>
          </StyledH6>
        </Col>
      </Row>

      {tables && all_tables ? (
        <>
          {tables.map((zoneTables) => (
            <div key={zoneTables[0].number}>
              <h5>{zoneTables[0].number}</h5>
              <ZoneContainer>
                {zoneTables.slice(1).map((table) => {
                  const zoneNumber = zoneTables?.[0]?.number || "defaultKey";
                  const isSelected = selectedTables?.[zoneNumber]?.some(
                    (t) => t.number === table.number
                  );
                  const the_table = all_tables.find(
                    (t) => t.id.toString() === table.number
                  );
                  return (
                    <StyledTableDiv
                      key={table.number}
                      isSelected={isSelected}
                      tableStatus={table.status}
                      onClick={() =>
                        handleTableSelect(table, zoneTables[0].number)
                      }
                    >
                      {the_table?.table_name}
                    </StyledTableDiv>
                  );
                })}
              </ZoneContainer>
            </div>
          ))}
        </>
      ) : (
        <Loader />
      )}
    </CustomModal>
  );
};

export default TablesModal;
